import { withViewerScope, type ViewerScopedQueryOptions } from "@/lib/viewer-scoped-query";
import { orpc } from "@/utils/orpc.client";
import { QUERY_STALE_TIMES } from "@/utils/query-policies";
import type { FormatCategoryWithOther } from "@garimpa/lib/formatGroups";
import type { OfferCondition } from "@garimpa/lib/offerConditions";

export type DealOffersQueryOptionsInput = { condition?: OfferCondition } & (
  | { releaseId: string; workId?: never; currency: string; format?: never }
  | {
      releaseId?: never;
      workId: string;
      currency: string;
      format?: FormatCategoryWithOther | "all";
    }
);

export function getDealOffersQueryOptions(
  input: DealOffersQueryOptionsInput,
  options: ViewerScopedQueryOptions = {},
) {
  return withViewerScope(
    orpc.deals.getOffers.queryOptions({
      input,
      staleTime: QUERY_STALE_TIMES.dealOffers,
    }),
    options.viewerId,
  );
}

export type OutOfStockDealOffersQueryOptionsInput =
  | { releaseId: string; workId?: never; currency: string; format?: FormatCategoryWithOther }
  | {
      releaseId?: never;
      workId: string;
      currency: string;
      format?: FormatCategoryWithOther;
    };

function getDealOfferSummaryInput(input: {
  condition?: OfferCondition;
  workId: string;
  releaseId?: string;
  currency: string;
  format?: FormatCategoryWithOther | "all";
}) {
  const summaryInput: {
    condition?: OfferCondition;
    workIds: string[];
    releaseIds?: string[];
    currency: string;
    format: FormatCategoryWithOther | "all" | undefined;
  } = {
    condition: input.condition,
    workIds: [input.workId],
    currency: input.currency,
    format: input.format,
  };
  if (input.releaseId) summaryInput.releaseIds = [input.releaseId];
  return summaryInput;
}

export function getOutOfStockDealOffersQueryOptions(
  input: OutOfStockDealOffersQueryOptionsInput,
  options: ViewerScopedQueryOptions = {},
) {
  return withViewerScope(
    orpc.deals.getOutOfStockOffers.queryOptions({
      input,
      staleTime: QUERY_STALE_TIMES.dealOffers,
    }),
    options.viewerId,
  );
}

export function getDealOfferSummaryQueryOptions(
  input: {
    condition?: OfferCondition;
    workId: string;
    releaseId?: string;
    currency: string;
    format?: FormatCategoryWithOther | "all";
  },
  options: ViewerScopedQueryOptions = {},
) {
  return withViewerScope(
    orpc.deals.getOfferSummaries.queryOptions({
      input: getDealOfferSummaryInput(input),
      staleTime: QUERY_STALE_TIMES.dealOffers,
    }),
    options.viewerId,
  );
}

export function getDealOfferPriceHistoryQueryOptions(
  input: { offerId: string; currency: string },
  options: ViewerScopedQueryOptions = {},
) {
  return withViewerScope(
    orpc.deals.getOfferPriceHistory.queryOptions({
      input,
      staleTime: QUERY_STALE_TIMES.dealOffers,
    }),
    options.viewerId,
  );
}
